import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActionSheetController, ModalController, ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { Comment } from 'src/app/shared/comments-modal/comment.model';
import { DoggogramService } from 'src/app/doggogram/doggogram.service';
import { CaseService } from 'src/app/lost-found/case.service';
import { AddCommentDTO } from './comments.dto';
import { AuthService } from 'src/app/auth/auth.service';
import { ReportService } from '../services/report.service';
import { ChatService } from 'src/app/chats/chats.service';

@Component({
  selector: 'app-comments-modal',
  templateUrl: './comments-modal.component.html',
  styleUrls: ['./comments-modal.component.css'],
})
export class CommentsModalComponent implements OnInit, OnDestroy {
  @Input() postid;
  @Input() caseId;
  @Input() userId;
  @Input() source;
  @Input() postUserId;
  comments: Comment[] = [];
  NewComment = '';
  isLoading = true;
  commentsCount = 0;
  getCommentSub: Subscription;
  addCommentSub: Subscription;
  deleteCommentSub: Subscription;
  isAdmin = false;
  constructor(
    private modalCtrl: ModalController,
    private doggogramService: DoggogramService,
    private caseService: CaseService,
    private toastController: ToastController,
    private actionSheetCtrl: ActionSheetController,
    private authService: AuthService,
    private reportService: ReportService,
    private chatService: ChatService
  ) {
    this.NewComment = '';
  }
  async ngOnInit() {
    this.isAdmin = await this.authService.isAdmin();
    this.getComments();
  }
  ngOnDestroy() {
    if (this.getCommentSub) this.getCommentSub.unsubscribe();
    if (this.addCommentSub) this.addCommentSub.unsubscribe();
    if (this.deleteCommentSub) this.deleteCommentSub.unsubscribe();
  }
  getComments() {
    if (this.source === 'doggogram') {
      this.getCommentSub = this.doggogramService
        .getComments(this.postid)
        .subscribe((comments) => {
          this.comments = comments;
          this.commentsCount = comments.length;
          this.isLoading = false;
        });
    } else if (this.source === 'case') {
      this.getCommentSub = this.caseService
        .getComments(this.caseId)
        .subscribe((comments) => {
          this.comments = comments;
          this.commentsCount = comments.length;
          this.isLoading = false;
        });
    }
  }
  onCancel() {
    this.modalCtrl.dismiss({
      commentsCount: this.commentsCount,
    });
  }
  addComment() {
    if (this.NewComment.trim().length === 0) {
      this.NewComment = '';
      return;
    }
    if (this.source === 'doggogram') {
      const addCommentDTO: AddCommentDTO = {
        comment: this.NewComment.trim(),
        postid: this.postid,
        userid: this.userId,
      };
      this.NewComment = '';
      this.addCommentSub = this.doggogramService
        .addComment(addCommentDTO)
        .subscribe({
          next: async (res) => {
            if (res.isCommentAdded) {
              this.comments.push(
                new Comment(
                  res.id,
                  res.userId,
                  res.username,
                  res.postId,
                  res.createdDate,
                  res.comment
                )
              );
              this.commentsCount = this.comments.length;
            } else {
              const toast = await this.toastController.create({
                color: 'danger',
                duration: 2000,
                message: 'Could not perform action. Please try again later.',
              });
              await toast.present();
            }
          },
          error: async () => {
            const toast = await this.toastController.create({
              color: 'danger',
              duration: 2000,
              message: 'Could not perform action. Please try again later.',
            });
            await toast.present();
          },
        });
    } else if (this.source === 'case') {
      const addCommentDTO: AddCommentDTO = {
        comment: this.NewComment.trim(),
        postid: this.caseId,
        userid: this.userId,
      };
      this.NewComment = '';
      this.addCommentSub = this.caseService
        .addComment(addCommentDTO)
        .subscribe({
          next: async (res) => {
            if (res.isCommentAdded) {
              this.comments.push(
                new Comment(
                  res.id,
                  res.userId,
                  res.username,
                  res.postId,
                  res.createdDate,
                  res.comment
                )
              );
              this.commentsCount = this.comments.length;
            } else {
              const toast = await this.toastController.create({
                color: 'danger',
                duration: 2000,
                message: 'Could not perform action. Please try again later.',
              });
              await toast.present();
            }
          },
          error: async () => {
            const toast = await this.toastController.create({
              color: 'danger',
              duration: 2000,
              message: 'Could not perform action. Please try again later.',
            });
            await toast.present();
          },
        });
    }
  }
  deleteComment(commentId: number) {
    if (this.source === 'doggogram') {
      const index = this.comments.findIndex((x) => x.id === commentId);
      const tempComment = this.comments[index];
      this.comments.splice(index, 1);
      this.commentsCount = this.comments.length;
      this.deleteCommentSub = this.doggogramService
        .deleteComment(commentId)
        .subscribe({
          next: async (res) => {
            this.commentsCount = res;
            const toast = await this.toastController.create({
              color: 'primary',
              duration: 2000,
              message: 'Comment deleted successfully.',
            });
            await toast.present();
          },
          error: async () => {
            this.comments.splice(index, 0, tempComment);
            this.commentsCount = this.comments.length;
            const toast = await this.toastController.create({
              color: 'danger',
              duration: 2000,
              message: 'Could not perform action. Please try again later.',
            });
            await toast.present();
          },
        });
    } else if (this.source === 'case') {
      const index = this.comments.findIndex((x) => x.id === commentId);
      const tempComment = this.comments[index];
      this.comments.splice(index, 1);
      this.commentsCount = this.comments.length;
      this.deleteCommentSub = this.caseService
        .deleteComment(commentId)
        .subscribe({
          next: async (res) => {
            this.commentsCount = res;
            const toast = await this.toastController.create({
              color: 'primary',
              duration: 2000,
              message: 'Comment deleted successfully.',
            });
            await toast.present();
          },
          error: async () => {
            this.comments.splice(index, 0, tempComment);
            this.commentsCount = this.comments.length;
            const toast = await this.toastController.create({
              color: 'danger',
              duration: 2000,
              message: 'Could not perform action. Please try again later.',
            });
            await toast.present();
          },
        });
    }
  }

  async presentActionSheet(comment) {
    const isUserAdded = comment.userid === this.userId || this.userId === this.postUserId || this.isAdmin;
    const buttons = [
      ...(isUserAdded
        ? [
          {
            text: 'Delete',
            icon: 'trash-outline',
            role: 'destructive',
            handler: () => {
              this.deleteComment(comment.id);
            },
            cssClass: 'danger-button',
          },
        ]
        : []), // Empty if condition is false
      ...(comment.userid !== this.userId
        ? [
          {
            text: 'Report Comment',
            icon: 'nuclear-outline',
            role: 'destructive',
            handler: () => {
              this.reportComment(comment.id);
            },
            cssClass: 'danger-button',
          },
        ]
        : []),
    ];

    const actionSheet = await this.actionSheetCtrl.create({
      buttons: buttons,
    });

    await actionSheet.present();
  }

  reportComment(commentId: number) {
    var type = this.source === 'doggogram' ? 'postComment' : 'caseComment';
    this.reportService.report(type, commentId.toString(), this.userId);
  }
  openUserOptions(userId: number, username: string) {
    this.chatService.openUserOptions(userId.toString(), username);
  }
}
